import type { AiToolCall } from '../api/ai';

/** Internal links only, bound to the successful call's current site. */
export function barkLinksFor(call: Pick<AiToolCall, 'name' | 'status' | 'args'>, siteSlug: string) {
  if (call.status !== 'ok' || !/^wpp_(schedule_bark|cancel_bark_item|reschedule_bark_item|retry_bark_item|list_bark_queue|get_bark)$/.test(call.name)) return null;
  const args = call.args as Record<string, unknown> | null;
  if (!args || args.site_slug !== siteSlug) return null;
  const kind = typeof args.content_type === 'string' ? args.content_type.replace(/^wpp_/, '') : '';
  const content = (kind === 'posts' || kind === 'pages') && typeof args.content_id === 'string' && args.content_id
    ? { kind, id: args.content_id, path: `/sites/${encodeURIComponent(siteSlug)}/${kind}/${encodeURIComponent(args.content_id)}` } : null;
  return { calendar: `/sites/${encodeURIComponent(siteSlug)}/bark`, content };
}
